let ENVIRONMENT = process.env.NODE_ENV as 'development' | 'production' | 'test' | 'staging';
if (ENVIRONMENT === 'production' && process.env.REACT_APP_STAGING === 'true') {
  ENVIRONMENT = 'staging';
}

export const SENTRY_DNS =
  'https://a68e41f015ef4a4199f22f2f6f9e78d0@o256157.ingest.sentry.io/4504849639407616';

export const GOOGLE_MAPS_API_KEY = 'AIzaSyCSHHhzKxa8ch6Z8cm-jrtRXq7CXVLvD6w';
export const GOOGLE_OAUTH_ID =
  '536746055782-echdg6un3kupe0nbhobv08mkv64sh62l.apps.googleusercontent.com';

// export const HSSCRIPT = {
//   production: '//js.hs-scripts.com/20631581.js',
//   staging: '//js.hs-scripts.com/20631581.js',
// }[ENVIRONMENT as string];

export const GTM_ARGS = {
  staging: { gtmId: 'GTM-NC2NBC9' },
  production: { gtmId: 'GTM-PHV3J92' },
}[ENVIRONMENT as string];

export const PERSONAL_FORM_ANSWERS = [
  'name',
  'gender',
  'birth_date',
  'residence_country',
  'nationality',
  'passport_status',
  'passport',
];
export const ACADEMIC_FORM_ANSWERS = [
  'school_name',
  'degree_type',
  'subject_type',
  'grade',
  'academic_start_year',
  'academic_start_month',
];
export const WORK_FORM_ANSWERS = [
  'working_area',
  'organization_name',
  'working_location',
  'job_title',
  'working_start_year',
  'working_start_month',
  'working_description',
];
export const TESTS_FORM_ANSWERS = [
  'english_exam',
  'english_exam_type',
  'score_english_exam',
  'english_exam_reading',
  'english_exam_listening',
  'english_exam_speaking',
  'english_exam_writing',
  'english_exam_date',
];

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const TUITION_RANGES = [
  ['Any', undefined, undefined],
  ['<5k', 0, 5],
  ['5-10k', 5, 10],
  ['10-20k', 10, 20],
  ['20-30K', 20, 30],
  ['30-50K', 30, 50],
  ['50K+', 50, null],
];

export const DEGREE_TYPES = [
  ['High School', 'high_school'],
  ["Bachelor's degree", 'bachelors_degree'],
  ["Master's degree", 'masters_degree'],
  ['MBA', 'mba'],
  ['PhD', 'phd'],
  ['Other degree', 'other'],
];

export const DEGREE_TYPES_PROFILING = [
  ["Bachelor's degree", 'bachelors'],
  ["Master's degree", 'masters'],
];

export const SUBJECT_TYPES = [
  ['Accounting', 'accounting_subject'],
  ['Agriculture', 'agriculture'],
  ['Architecture', 'architecture'],
  ['Arts', 'arts'],
  ['Business', 'business'],
  ['Computer Science', 'computer_science'],
  ['Economics', 'economics_subject'],
  ['Engineering', 'engineering'],
  ['Finance', 'finance_subject'],
  ['Humanities', 'humanities'],
  ['Law', 'law'],
  ['Media Related Communication', 'media_related_communication'],
  ['Medicine', 'medicine'],
  ['Nursing', 'nursing'],
  ['Psychology', 'psychology'],
  ['Other', 'other_subject_type'],
];

export const WORKING_AREAS = [
  ['Accounting', 'accounting'],
  ['Administration', 'administration'],
  ['Consulting', 'consulting'],
  ['Economics', 'economics'],
  ['Education', 'education'],
  ['Engineering Services', 'engineering_services'],
  ['Entertainment', 'enterteinment'],
  ['Finance', 'finance'],
  ['Health Services', 'health_services'],
  ['Hospitality', 'hospitality'],
  ['Human Resources', 'human_resources'],
  ['Innovation', 'innovation'],
  ['Investment Banking', 'investment_banking'],
  ['Management Consulting', 'management_consulting'],
  ['Marketing', 'marketing'],
  ['Operations', 'operations'],
  ['Private Equity', 'private_equity'],
  ['Project Management', 'project_management'],
  ['Sales', 'sales'],
  ['Supply Chain', 'supply_chain'],
  ['Trading', 'trading'],
  ['Training & Development', 'training_and_development'],
  ['Other', 'other'],
];

export const ENGLISH_TESTS = [
  ['IELTS', 'ielts'],
  ['Toefl iBT', 'toefl'],
  ['Duolingo', 'duolingo'],
  ['Other', 'other_english_exam'],
];

export const ACADEMIC_TESTS = [
  ['GMAT', 'gmat'],
  ['GRE', 'gre'],
  ['SAT', 'sat'],
  ['Other', 'other_technical_exam'],
];

export const LANDING_COMPONENTS = [
  ['Hero Banner', 'hero_banner'],
  ['Markdown', 'markdown'],
  ['Youtube Video Insert', 'youtube_video'],
  ['Card Grid', 'card_grid'],
  ['FAQ', 'faq'],
  ['Content Grid', 'content_grid'],
  ['Webinar', 'webinar'],
  ['Banner', 'banner'],
  ['HTML Outer Script', 'html_outer_script'],
  ['HTML Inner Script', 'html_inner_script'],
  ['Title', 'title'],
  ['Search Bar', 'search_bar'],
  ['Newsletter subscription banner', 'newsletter_banner'],
  ['Testimonial', 'testimonial'],
  ['Generic Form', 'form'],
];

export const LANDING_BACKGROUND_OPTIONS = [
  ['white', 'white'],
  ['light blue', 'lightblue'],
  ['light yellow', 'lightyellow'],
  ['dark blue', 'darkblue'],
  ['Select Custom', 'custom'],
  ['Upload Image', 'image'],
];

export const LANDING_CARD_STYLES = [
  ['Simple (with icon)', 'simple'],
  ['Standard (with image)', 'standard'],
  ['Image on side', 'side_image'],
  ['Only image', 'only_image'],
  ['Just Text', 'just_text'],
];

export const CONTENT_GRID_TYPES = [
  ['Subjects', 'subjects'],
  ['Programs', 'programs'],
  ['Schools', 'schools'],
  ['Cities', 'cities'],
  ['Countries', 'countries'],
  ['Blogs', 'blogs'],
];

export const GENDERS = ['Male', 'Female', 'Other'];

export const RESIDENT_COUNTRIES = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas (the)',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia (Plurinational State of)',
  'Bonaire, Sint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory (the)',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cabo Verde',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cayman Islands (the)',
  'Central African Republic (the)',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands (the)',
  'Colombia',
  'Comoros (the)',
  'Congo (the Democratic Republic of the)',
  'Congo (the)',
  'Cook Islands (the)',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Curaçao',
  'Cyprus',
  'Czechia',
  "Côte d'Ivoire",
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic (the)',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Eswatini',
  'Ethiopia',
  'Falkland Islands (the) [Malvinas]',
  'Faroe Islands (the)',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories (the)',
  'Gabon',
  'Gambia (the)',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See (the)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran (Islamic Republic of)',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  "Korea (the Democratic People's Republic of)",
  'Korea (the Republic of)',
  'Kuwait',
  'Kyrgyzstan',
  "Lao People's Democratic Republic (the)",
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands (the)',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia (Federated States of)',
  'Moldova (the Republic of)',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands (the)',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger (the)',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands (the)',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine, State of',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines (the)',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Republic of North Macedonia',
  'Romania',
  'Russian Federation (the)',
  'Rwanda',
  'Réunion',
  'Saint Barthélemy',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin (French part)',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan (the)',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands (the)',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates (the)',
  'United Kingdom of Great Britain and Northern Ireland (the)',
  'United States Minor Outlying Islands (the)',
  'United States of America (the)',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela (Bolivarian Republic of)',
  'Viet Nam',
  'Virgin Islands (British)',
  'Virgin Islands (U.S.)',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
  'Åland Islands',
];

export const NATIONALITIES = [
  'British',
  'Afghan',
  'Albanian',
  'Algerian',
  'American',
  'Andorran',
  'Angolan',
  'Armenian',
  'Austrian',
  'Azerbaijani',
  'Argentinian',
  'Australian',
  'Bahraini',
  'Bangladeshi',
  'Barbadian',
  'Belarusian',
  'Belizean',
  'Beninese',
  'Bermudian',
  'Bhutanese',
  'Bolivian',
  'Bosnian',
  'Botswanan',
  'Bulgarian',
  'Burkinese',
  'Burundian',
  'Canadian',
  'Chinese',
  'Colombian',
  'Cuban',
  'Cambodian',
  'Cameroonian',
  'Cape Verdean',
  'Chadian',
  'Chilean',
  'Congolese',
  'Costa Rican',
  'Croat',
  'Cypriot',
  'Czech',
  'Danish',
  'Dominican',
  'Djiboutian',
  'Dominican',
  'Dutch',
  'Ecuadorean',
  'Egyptian',
  'Eritrean',
  'Estonian',
  'Ethiopian',
  'Fijian',
  'Finnish',
  'French Polynesian',
  'French',
  'Gabonese',
  'Gambian',
  'Georgian',
  'German',
  'Guatemalan',
  'Ghanaian',
  'Greek',
  'Grenadian',
  'Guinean',
  'Guyanese',
  'Haitian',
  'Honduran',
  'Hungarian',
  'Indian',
  'Ireland',
  'Israeli',
  'Italian',
  'Icelandic',
  'Indonesian',
  'Iranian',
  'Iraqi',
  'Japanese',
  'Jamaican',
  'Jordanian',
  'Kazakh',
  'Kenyan',
  'North Korean',
  'Kuwaiti',
  'Latvian',
  'Lebanese',
  'Liberian',
  'Libyan',
  'Lithuanian',
  'LUXEMBOURG',
  'Madagascan',
  'Malawian',
  'Malaysian',
  'Maldivian',
  'Malian',
  'Maltese',
  'Mauritanian',
  'Mauritian',
  'Monacan',
  'Mongolian',
  'Montenegrin',
  'Moroccan',
  'Mozambican',
  'Mexican',
  'Namibian',
  'Nepalese',
  'New Zealand',
  'Nicaraguan',
  'Nigerien',
  'Nigerian',
  'Norwegian',
  'Omani',
  'Pakistani',
  'Panamanian',
  'Guinean',
  'Paraguayan',
  'Peruvian',
  'Philippine',
  'Polish',
  'Portuguese',
  'Qatari',
  'Romanian',
  'Rwandan',
  'Salvadorean',
  'Samoan',
  'Saudi Arabian',
  'Senegalese',
  'Serbian',
  'Sierra Leonian',
  'Singaporean',
  'Slovak',
  'Slovenian',
  'Slomoni',
  'Somali',
  'South African',
  'South Korean',
  'Spanish',
  'Swedish',
  'Swiss',
  'Sri Lankan',
  'Sudanese',
  'Surinamese',
  'Swazi',
  'Taiwanese',
  'Tajik',
  'Thai',
  'Togolese',
  'Trinidadian',
  'Tunisian',
  'Turkish',
  'Turkoman',
  'Tuvaluan',
  'Ugandan',
  'Ukrainian',
  'Emirati',
  'Venezuelan',
  'Vietnamese',
  'Uruguayan',
  'Uzbek',
  'Vanuatuan',
  'Yemeni',
  'Zambian',
];

export const documentText: { [key: string]: string } = {
  profile:
    'Please fill your personal information, passport photo, academic background, \
      and work experience. This information is critical for universities to start \
      processing your application.',
  'English proof':
    'Please upload your scores English test scores in pdf format. If you \
    are a citizen from an English Speaking Country you can omit this step.',
  'Degree Certificate':
    'Please upload your university degree certificates. \
      If you have more than one please attach them as only one file.',
  Transcripts:
    'Please upload the transcripts of your most recent studies, \
      the file must be in English. If your school don’t provide them in English \
      please use an official translator to translate them.',
  'Reference letter':
    'Please upload 2 recommendation letters from previous employers or professors.',
  'Degree certificate':
    'Please upload your university degree certificates. If you have \
      more than one please attach them as only one file.',
  'Personal statement':
    'This is one of the most important sections of your application, please make sure \
      to write at least 1 page where you explain why you want to study Full-time MBA in \
      Audencia Business School. It also gives you the opportunity to showcase why you are \
      a good fit for the program.',
  'Technical test':
    'Please upload your scores English test scores in pdf format. While the program doesn’t \
      require a GMAT/GRE score if you already did the test and have a good score it can improve \
      your application.',
};
export const GPASCALEVALUES = [
  {
    gpa: '4.0',
    '10point': '8.5 - 10',
    percentageScale: '85 - 100',
    ukScale: 'First class honours',
    '100scale': '850 - 1000',
    grade: 'A+',
    '7point': '6.5 - 7',
  },
  {
    gpa: '3.7',
    '10point': 'S',
    percentageScale: '80 - 84',
    ukScale: 'Upper-second class honours',
    '100scale': '800 - 840',
    grade: 'A',
    '7point': '6.0 - 6.4',
  },
  {
    gpa: '3.3',
    '10point': '7.5 - 7.9',
    percentageScale: '75 - 79',
    ukScale: 'Upper-second class honours',
    '100scale': '750 - 790',
    grade: 'B+',
    '7point': '5.5 - 5.9',
  },
  {
    gpa: '3',
    '10point': '7.0 - 7.4',
    percentageScale: '70 - 74',
    ukScale: 'Lower-second class honours',
    '100scale': '700 - 740',
    grade: 'B',
    '7point': '5.0 - 5.4',
  },
  {
    gpa: '2.7',
    '10point': '6.5 - 6.9',
    percentageScale: '65 - 69',
    ukScale: 'Lower-second class honours',
    '100scale': '650 - 690',
    grade: 'B-',
    '7point': '4.5 - 4.9',
  },
  {
    gpa: '2.3',
    '10point': '6.0 - 6.4',
    percentageScale: '60 - 64',
    ukScale: 'Third class honours',
    '100scale': '600 - 640',
    grade: 'C+',
    '7point': '4.3 - 4.4',
  },
  {
    gpa: '2',
    '10point': '5.5 - 5.9',
    percentageScale: '55 - 59',
    ukScale: 'Third class honours',
    '100scale': '550 - 590',
    grade: 'C',
    '7point': '4.1 - 4.2',
  },
  {
    gpa: '1.7',
    '10point': '5.0 - 5.4',
    percentageScale: '50 - 54',
    ukScale: 'Ordinary',
    '100scale': '500 - 540',
    grade: 'C-',
    '7point': '4',
  },
  {
    gpa: '1.3',
    '10point': '4.5 - 4.9',
    percentageScale: '45 - 49',
    ukScale: 'Ordinary',
    '100scale': '450 - 490',
    grade: 'D',
    '7point': '< 4',
  },
  {
    gpa: '1.0',
    '10point': '4.0 - 4.4',
    percentageScale: '40 - 44',
    ukScale: 'Ordinary',
    '100scale': '400 - 440',
    grade: 'D',
    '7point': '< 4',
  },
  {
    gpa: '0',
    '10point': '< 4.0',
    percentageScale: '< 40',
    ukScale: 'Fail',
    '100scale': '< 400',
    grade: 'F',
    '7point': '< 4',
  },
];

export const GPASCALE = [
  ['gpa', '4 point GPA (US Standard)'],
  ['10point', '10 point GPA'],
  ['percentageScale', 'Percentage Scale'],
  ['ukScale', 'UK Scale'],
  ['100scale', '1100 Scale System'],
  ['grade', 'Grade System'],
  ['7point', '7 point GPA'],
];

export const GPASCALEPOSITION = {
  gpa: 0,
  '10point': 1,
  percentageScale: 2,
  ukScale: 3,
  '100scale': 4,
  grade: 5,
  '7point': 6,
};

export const TITLESIZE = {
  xl: 'fs-0 mt-2 mb-4',
  lg: 'fs-1 mt-2 mb-3 fw-semibold',
  default: 'fs-2 mt-2 mb-3 fw-semibold',
  sm: 'fs-3 mt-1 mb-2 fw-semibold',
  xs: 'fs-4 mt-1 mb-2 fw-semibold',
};

export const TEXTCOLOR = {
  default: '',
  'dark-primary': 'text-dark-primary',
  primary: 'text-primary',
  'light-primary': 'text-light-primary',
  secondary: 'text-secondary',
  success: 'text-success',
  warning: 'text-warning',
  danger: 'text-danger',
  light: 'text-light',
  white: 'text-white',
};

export const ALIGNMENT = {
  left: 'text-md-start',
  middle: 'text-md-center',
  right: 'text-md-end',
};

export const SECTIONTITLEALIGNMENT = {
  left: 'justify-content-md-start',
  middle: 'justify-content-md-center',
  right: 'justify-content-md-end',
};

export const BADGECOLOR = {
  'dark-primary': 'text-bg-dark-primary',
  primary: 'text-bg-primary',
  'light-primary': 'text-bg-light-primary',
  secondary: 'text-bg-secondary',
  success: 'text-bg-success',
  warning: 'text-bg-warning',
  danger: 'text-bg-danger',
  light: 'text-bg-light',
};

export const DESCRIPTIONSIZE = {
  default: '',
  lg: 'fs-5',
  sm: 'fs-7',
};

export const BUTTONSTYLE = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  light: 'btn-light',
  success: 'btn-success',
  warning: 'btn-warning',
  danger: 'btn-danger',
  'dark-primary': 'btn-dark-primary',
  'light-primary': 'btn-light-primary',
  'outline-primary': 'btn-outline-primary',
  'outline-secondary': 'btn-outline-secondary',
  'outline-light': 'btn-outline-light',
  'outline-success': 'btn-outline-success',
  'outline-warning': 'btn-outline-warning',
  'outline-danger': 'btn-outline-danger',
  'outline-dark-primary': 'btn-outline-primary',
  'outline-light-primary': 'btn-outline-light-primary',
};

export const BUTTONSIZE = {
  lg: 'btn-lg',
  default: '',
  sm: 'btn-sm',
};

export const TITLESIZEOPTIONS = ['default', 'xl', 'lg', 'sm', 'xs'];

export const TEXTCOLOROPTIONS = [
  'default',
  'dark-primary',
  'primary',
  'light-primary',
  'secondary',
  'warning',
  'danger',
  'success',
  'light',
  'white',
];
export const ALIGNMENTOPTIONS = ['left', 'middle', 'right'];

export const BADGECOLOROPTIONS = [
  'primary',
  'dark-primary',
  'light-primary',
  'secondary',
  'warning',
  'danger',
  'success',
  'light',
];

export const DESCRIPTIONSIZEOPTIONS = ['default', 'lg', 'sm'];

export const TITLETYPEOPTIONS = ['default', 'main'];

export const BUTTONSTYLEOPTIONS = [
  'primary',
  'secondary',
  'success',
  'warning',
  'danger',
  'light',
  'dark-primary',
  'light-primary',
  'outline-primary',
  'outline-secondary',
  'outline-success',
  'outline-warning',
  'outline-danger',
  'outline-light',
  'outline-dark-primary',
  'outline-light-primary',
];

export const BUTTONSIZEOPTIONS = ['default', 'lg', 'sm'];
